import React from 'react';
import block from 'bem-cn';

import SVG from 'components/SVG';

import CheckSVG from './img/check.svg';
import CircleSVG from './img/check-circle.svg';

import './CheckBox.scss';

const b = block('check-box-desktop');

const CheckBox = ({ checked, name, onChange, type }) => {
  if (type === 'circle') {
    return (
      <label className={b({ check: checked, type: 'circle' })}>
        {checked && <SVG className={b('circle').toString()} svgProps={{ svg: CircleSVG }} />}
        <input className={b('input')} name={name} type="checkbox" checked={checked} onChange={onChange} />
      </label>
    );
  }
  return (
    <label className={b({ check: checked })}>
      {checked && <SVG className={b('check').toString()} svgProps={{ svg: CheckSVG }} />}
      <input className={b('input')} name={name} type="checkbox" checked={checked} onChange={onChange} />
    </label>
  );
};

export default CheckBox;
